import React, { useContext } from "react";
import { __RouterContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Icon, Menu } from "semantic-ui-react";

const TopMenuWithBackButton = ({ header }) => {
  const context = useContext(__RouterContext);
  const menuHeight = "71px";
  return (
    <>
      <Menu
        borderless
        fixed="top"
        style={{ maxWidth: "100vw", width: "100%", height: menuHeight }}
        inverted
        icon="labeled"
      >
        <Menu.Item onClick={() => context.history.goBack()}>
          <Icon name="arrow left" />
          BACK
        </Menu.Item>
        <Menu.Item>
          <Menu.Header
            as="h3"
            style={{ marginTop: "auto", marginBottom: "auto" }}
          >
            {header}
          </Menu.Header>
        </Menu.Item>
      </Menu>
      <div style={{ height: menuHeight }}></div>
    </>
  );
};

TopMenuWithBackButton.propTypes = {
  header: PropTypes.string,
};

export default TopMenuWithBackButton;
